import {call, put, takeLatest} from 'redux-saga/effects';
import {base_url, endpoints} from '../../../constants';
import {AxiosService} from '../../../services';
import {actionTypes} from '../../../types';
import {
    sendOtpForMobileVerifiedFailure,
    sendOtpForMobileVerifiedSuccess
} from "../../actions/authActions/sendOtpForMobileVerifiedAction";
import {setSessonToken} from "../../../publicStore/actions/utilsActions/utilsActions";

function* sendOtpForMobileVerified({ payload }) {
    try {
        const response = yield call(AxiosService, {
            method: 'post',
            base_url: base_url,
            endPoint: endpoints.sendOtpForMobileVerified,
            payload: payload,
            isAuth: true,
        });
        console.log('====================================');
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS status :", response.data.status);
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS data :", response.data.response);
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_SUCCESS message :", response.data.message);
        console.log('====================================');
        yield put(
            sendOtpForMobileVerifiedSuccess({
                status: response?.data?.status,
                response: response?.data?.response,
                message: response?.data?.message
            })
        );
        yield put(setSessonToken(response?.data?.response));
    } catch (error) {
        console.log('====================================');
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE status :", error?.response?.status);
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE data:", error?.response?.data);
        console.log("SEND_OTP_FOR_MOBILE_VERIFIED_FAILURE error :", error);
        console.log('====================================');
        yield put(sendOtpForMobileVerifiedFailure({
            status: error?.response?.data?.status,
            response: {},
            message: error?.response?.data?.message
        }));
    }
}

function* sendOtpForMobileVerifiedSaga() {
    yield takeLatest(actionTypes.SEND_OTP_FOR_MOBILE_VERIFIED_REQUEST, sendOtpForMobileVerified);
}

export default sendOtpForMobileVerifiedSaga;
